/**
 * cyber-nav.js
 *
 * Marca con la clase .is-cyber todo link del menu principal (cascade-nav)
 * cuyo nombre contenga "cyber" (sin importar mayusculas). Asi el boton se
 * pinta de rojo sin depender de la URL de la coleccion: Framondi puede
 * cambiar el destino o el submenu sin tocar el codigo.
 *
 * Los estilos del rojo viven en sections/header.liquid (.is-cyber).
 */
(function () {
  'use strict';

  var LINK_SELECTOR = '.cascade-nav .cascade-nav__link';
  var CYBER_PATTERN = /cyber/i;

  function markCyberLinks(root) {
    var links = (root || document).querySelectorAll(LINK_SELECTOR);
    for (var i = 0; i < links.length; i++) {
      links[i].classList.toggle('is-cyber', CYBER_PATTERN.test(links[i].textContent));
    }
  }

  markCyberLinks();

  // Por si el script corre antes de que exista el menu.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      markCyberLinks();
    });
  }

  // Editor de temas: el header se vuelve a renderizar al editar la seccion.
  document.addEventListener('shopify:section:load', function (event) {
    markCyberLinks(event.target);
  });
})();
